import React from 'react';
import CRMPro from './crm/CRMPro';

// Unified Lead CRM. The legacy "Classic" tabs were removed and all of their
// functions (Auto-Scheduler, 31-day Drip, WhatsApp Hot Alerts, AI Leads,
// Notifications) now live inside CRM Pro's view-switcher / header.
export default function LeadCRM({ token, language = 'hi' }) {
  return (
    <div className="p-4 md:p-6 max-w-7xl mx-auto" data-testid="lead-crm-page">
      <CRMPro token={token} />
    </div>
  );
}
